<template>
  <v-container>
    <v-row>
      <main-header-plat-a />
    </v-row>
    <v-col class="mt-8 mb-4">
      <strong class="d-flex primary--text justify-center text-subtitle-1">MI CUENTA</strong>
    </v-col>
    <v-row class="d-flex justify-center fluid flex-sm-wrap flex-lg-nowrap">
      <v-col>
        <v-card-pro-account-form
          :schemaForm="schema.schemaForm"
          :modelForm="modelForm"
          :cardProAccount1="schema.cardProAccount1"
          :dialogAccountPin="schema.dialogAccountPin"
          :dialogAccountPass="schema.dialogAccountPass"
          :schemaFormPass="schema.schemaFormPass"
          :dialogAccountDel="schema.dialogAccountDel"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import MainHeaderPlatA from '@/components/includes/MainHeaderPlatA.vue';
import VCardProAccountForm from '@/components/base/VCardProAccountForm.vue';
// import VCardProAccountDevice from '@/components/base/VCardProAccountDevice.vue'

export default {
  name: 'ProAccountPage',
  components: {
    MainHeaderPlatA,
    VCardProAccountForm,
    // VCardProAccountDevice
  },
  data() {
    return {};
  },
  mounted() {
    this.loadSchema();
    this.loadModelForm();
  },
  computed: {
    ...mapGetters('proAccountPage', ['schema', 'modelForm', 'status']),
  },
  methods: {
    ...mapActions('proAccountPage', ['loadSchema', 'loadModelForm']),

    // async delAccount() {
    //   let model = {};
    //   model.delAccount = true;

    //   this.$store.dispatch('proAccountPage/delAccount', model).then(
    //     () => { this.snackbarOpen() },
    //     error => { this.snackbarOpen() }
    //   )
    // },
    // snackbarOpen() {
    //   this.snackbar.visible = false;
    //   if (this.status === "success") {
    //     this.snackbar.visible = true;
    //     this.snackbar.content = this.schema.snackOkRemoved;
    //     this.outlog();
    //   } else if (this.status === "error") {
    //     this.snackbar.visible = true;
    //     this.snackbar.content = this.schema.snackError;
    //     this.reload();
    //   };
    // },
    // reload() {
    //   this.loadSchema()
    //   this.loadModelForm()
    // },
    // outlog() {
    //   let outlog = "/";
    //   this.$router.push(outlog);
    // }
  },
};
</script>
